import { render, staticRenderFns } from "./BulkUpdateClassesComponent.vue?vue&type=template&id=5f242a68"
import script from "./BulkUpdateClassesComponent.vue?vue&type=script&lang=js"
export * from "./BulkUpdateClassesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports